import { t as defaultT } from '../config';
import meta from '../../package.json';

export function t(key: string, name = meta.name) {
  return defaultT(key, name);
}

export default t;
